// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var MarkupFormula;
(function (MarkupFormula) {
    MarkupFormula[MarkupFormula["None"] = -1] = "None";
    MarkupFormula[MarkupFormula["OpenAndClose"] = 0] = "OpenAndClose";
    MarkupFormula[MarkupFormula["Pnl"] = 1] = "Pnl";
    MarkupFormula[MarkupFormula["MarginOpenAndClose"] = 2] = "MarginOpenAndClose";
})(MarkupFormula || (MarkupFormula = {}));
